export const state = () => ({
    employees: {
        total: 0,
        totalPages: 0,
        data: [],
    },
})

export const actions = {
    async getEmployees({ commit }, params) {
        await this.$axios
            .get('/operators/employees', { params })
            .then((response) => {
                commit('setEmployees', response.data)
            })
            .catch(() => {
                return false
            })
    },
    async updateEmployeeStatus({ commit }, { id, body }) {
        try {
            const updateResponse = await this.$axios
                .put(`/operators/employees/status/${id}`, body)
                .then((response) => {
                    return true
                })
                .catch(() => {
                    return false
                })
            return updateResponse
        } catch (error) {}
    },
}

export const mutations = {
    setEmployees(state, data) {
        state.employees = data
    },
}
